import Axios from '../axios'
import { serialize, deserialize } from '../utility/serialization'
import { requestCheckExportStatus } from './reportsActions'

// Program Reports are view-local and transient (no Redux slice): the report
// list and per-card generation status live in component state. These are thin
// async helpers over the shared axios instance (auth token + error handling).

const POLL_INTERVAL_MS = 2000
const MAX_POLL_ATTEMPTS = 90 // ~3 minutes at 2s intervals

// GET the registry-driven list of report cards for a program.
export const fetchProgramReports = (courseId) =>
  Axios.get(`api/v1/courses/${courseId}/reports`).then(({ data }) => deserialize(data).reports)

// POST to regenerate a report on demand; resolves to the async job id.
export const generateProgramReport = (courseId, reportType) =>
  Axios.post(`api/v1/courses/${courseId}/reports`, serialize({ reportType }))
    .then(({ data }) => deserialize(data).jobId)

// Poll GET /api/v1/jobs/:id until the export succeeds; resolves to the file URL.
export const pollProgramReport = (jobId) =>
  new Promise((resolve, reject) => {
    let attempts = 0

    const check = () => {
      attempts += 1
      requestCheckExportStatus(jobId)
        .then(({ data }) => {
          const job = deserialize(data.job)

          if (job.status === 'success') {
            resolve(job.parsedResult.fileUrl)
          } else if (job.status === 'error') {
            reject(new Error('Report generation failed'))
          } else if (attempts >= MAX_POLL_ATTEMPTS) {
            reject(new Error('Report generation timed out'))
          } else {
            setTimeout(check, POLL_INTERVAL_MS)
          }
        })
        .catch(reject)
    }

    check()
  })
